export var META_REACTIONS_URL_NAME = 'ajs-fabric-reactions-url';
export var QUICK_EMOJI_IDS = ['1f44d',
// thumbs up
'1f44f',
// clapping hands
'1f525',
// fire
'2764' // heart
];
export var QUICK_PICK_EMOJI_IDS = [];